/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B110020 商品分類別売上実績表
 */
import {
  B000111ShobunNm1From,
  B000111ShobunNm1To,
  B000111TokuibunNm1,
  B000111TokuibunNm2,
  B000120EigyoNmr,
  catchFileError,
} from "clients/rest";
import { B110020GetExcel, B110020Request } from "clients/rest/b110/B110020";
import {
  msgState,
  SCodeSelect,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { B110020ShokaKbn, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B000111 } from "pages";
import { B000120 } from "pages/b000/B000120";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download, yearMonth } from "services";
import { meishoKbn } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  taishoYm: string;
  eigyoCd: string;
  eigyoNmr: string;
  shokaKbn: SCode;
  tokuibunCd1: string;
  tokuibunNm1: string;
  tokuibunCd2: string;
  tokuibunNm2: string;
  shobunCd1From: string;
  shobunNm1From: string;
  shobunCd1To: string;
  shobunNm1To: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  taishoYm: yearMonth(),
  eigyoCd: "",
  eigyoNmr: "",
  shokaKbn: getSCode(B110020ShokaKbn, "9"),
  tokuibunCd1: "",
  tokuibunNm1: "",
  tokuibunCd2: "",
  tokuibunNm2: "",
  shobunCd1From: "",
  shobunNm1From: "",
  shobunCd1To: "",
  shobunNm1To: "",
};

const focusId = "B110020";

export const B110020 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // //Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    //   // Excel出力フォームのデータを取得する。
    const fields = methods.getValues();

    const param: B110020Request = {
      taishoYm: fields.taishoYm,
      eigyoCd: fields.eigyoCd,
      shokaKbn: fields.shokaKbn?.value,
      tokuibunCd1: fields.tokuibunCd1,
      tokuibunCd2: fields.tokuibunCd2,
      shobunCd1From: fields.shobunCd1From,
      shobunCd1To: fields.shobunCd1To,
    };

    (async () => {
      await B110020GetExcel(param)
        .then((response) => {
          download(response);
          setMsg(getClientMessage("B100020_001"));
        })
        .catch((reason) => {
          catchFileError(reason, navigate, setMsg);
        });
      focus(1);
    })();
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="商品分類別売上実績表"
        gridTemplateColumns="7rem 5rem 9rem 1rem 5rem 9rem"
      >
        <SLabel required>対象年月</SLabel>
        <SNumberField
          name="taishoYm"
          label="対象年月"
          code
          required
          size={6}
          {...register(1)}
        />
        <SText align="left">月度</SText>

        <SLabel required gridColumn="1">
          営業所
        </SLabel>
        <SNumberField
          name="eigyoCd"
          code
          size={6}
          {...register(2)}
          onBlur={() => B000120EigyoNmr(methods, navigate, setMsg)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCd", data.eigyoCd);
            methods.setValue("eigyoNmr", data.eigyoNmr);
          }}
        />
        <STextField name="eigyoNmr" disabled />

        <SLabel gridColumn="1">消化区分</SLabel>
        <SCodeSelect
          name="shokaKbn"
          options={B110020ShokaKbn}
          {...register(3)}
        />

        <SLabel gridColumn="1">得意先分類1</SLabel>
        <SNumberField
          name="tokuibunCd1"
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.tokuibun1} />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuibunCd1", data?.meishoCd);
            methods.setValue("tokuibunNm1", data?.meishoNm1);
          }}
          onBlur={() => B000111TokuibunNm1(methods, navigate, setMsg)}
          {...register(4)}
        />
        <STextField name="tokuibunNm1" disabled />

        <SLabel gridColumn="1">得意先分類2</SLabel>
        <SNumberField
          name="tokuibunCd2"
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.tokuibun2} />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuibunCd2", data?.meishoCd);
            methods.setValue("tokuibunNm2", data?.meishoNm1);
          }}
          onBlur={() => B000111TokuibunNm2(methods, navigate, setMsg)}
          {...register(5)}
        />
        <STextField name="tokuibunNm2" disabled />

        <SLabel gridColumn={1}>商品分類１</SLabel>
        <SNumberField
          name="shobunCd1From"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun1} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd1From", data.meishoCd);
            methods.setValue("shobunNm1From", data.meishoNm1);
          }}
          onBlur={() => B000111ShobunNm1From(methods, navigate, setMsg)}
          {...register(6)}
        />
        <STextField name="shobunNm1From" disabled />
        <SText>～</SText>
        <SNumberField
          name="shobunCd1To"
          code
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.shohinbun1} />}
          handleSubmit={(data: any) => {
            methods.setValue("shobunCd1To", data.meishoCd);
            methods.setValue("shobunNm1To", data.meishoNm1);
          }}
          onBlur={() => B000111ShobunNm1To(methods, navigate, setMsg)}
          {...register(7)}
        />
        <STextField name="shobunNm1To" disabled size={12} />

        <SFileButton
          label={labels.buttons.excel}
          gridRow={7}
          gridColumn={6}
          {...register(8)}
          align="right"
          onClick={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
